module.exports = __webpack_public_path__ + "img/report-guide.3aa9b6cb.svg";